import { createContext, useContext, useEffect, useState } from "react";
import { fetchAppConfig } from "../services/organisations.service";
import { fetchModules } from "../services/modeling.service";
import { DataContext } from "./DataProvider";
import { sidebarMapping } from "../base/sidebarMapping";
import routesMapping from "../constants/routesMapping";
import { matchPath } from "react-router-dom";

interface AppContextProps {
  data: {
    customer: any;
    customerImages: any[];
    user: any;
    appConfig?: any;
    currentModuleSidebar?: any[];
  };
  modules: any[] | null;
  setModules: any;
  setData: any;
}

export const AppContext = createContext<AppContextProps>({
  data: {
    customer: null,
    customerImages: [],
    user: {},
    currentModuleSidebar: [],
  },
  modules: null,
  setModules: null,
  setData: () => {},
});

// const hiddenModuleIds = ["6494f7c491f32ee316f6c653"];

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState(() => ({
    customer: null,
    customerImages: [],
    user: null,
    appConfig: null,
    currentModuleSidebar:
      sidebarMapping?.[
        routesMapping.find((route) =>
          matchPath(route.path, window.location.pathname)
        )?.sidebarName
      ] || [],
  }));
  const [modules, setModules] = useState<any[] | null>(null);
  const { login } = useContext(DataContext);

  useEffect(() => {
    (async () => {
      try {
        const appConfig = await fetchAppConfig();
        setData((prev) => ({ ...prev, appConfig }));
      } catch (error) {
        console.error("Error fetching app config:", error);
      }
    })();
  }, []);

  useEffect(() => {
    login.isLoggedIn &&
      (async () => {
        try {
          const resp: any = await fetchModules();
          setModules(resp.modules);
        } catch (error) {
          console.error("Error fetching modules:", error);
        }
      })();
  }, [login.isLoggedIn]);

  return (
    <AppContext.Provider value={{ data, modules, setModules, setData }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
